// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__UUDBe","CenterTabs":"Container_CenterTabs__gXVcq","Label":"Container_Label__UcFdK"};